import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ApiService from "../../Service/ApiService";
import { notify } from "../common/Toast";
import "../common/forms.css";

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      notify("Please enter your email address.", "error");
      return;
    }

    setLoading(true);
    const response = await ApiService.forgotPassword(email);
    if (response) {
      setEmail("");
      navigate("/login", { replace: true });
    }
    setLoading(false);
  };

  return (
    <div className="form-page-container auth-form">
      <h2>Forgot Password</h2>
      <p className="auth-helper-text">
        Enter your email address and we will send you a link to reset your password.
      </p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email: </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className={loading ? "disabled" : undefined}
          disabled={loading}
        >
          {loading ? "Please wait..." : "Send reset link"}
        </button>
      </form>
      <p className="register-link">
        Remembered your password? <Link to="/login">Login</Link>
      </p>
    </div>
  );
}

export default ForgotPasswordPage;